var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiConditionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06 7.23492L2 6.29492L4.06 5.35492L5 3.29492L5.94 5.35492L8 6.29492L5.94 7.23492L5 9.29492L4.06 7.23492ZM5 19.2949L5.94 17.2349L8 16.2949L5.94 15.3549L5 13.2949L4.06 15.3549L2 16.2949L4.06 17.2349L5 19.2949ZM1.37 10.6649L0 11.2949L1.37 11.9249L2 13.2949L2.63 11.9249L4 11.2949L2.63 10.6649L2 9.29492L1.37 10.6649ZM16 18.7049C16 19.4849 15.16 19.9549 14.49 19.5649C11.21 17.6549 9 14.0849 9 10.2949C9 7.56492 10.08 5.02492 11.75 3.04492L9.85 1.14492C9.54 0.834922 9.76 0.294922 10.21 0.294922H15.5C15.78 0.294922 16 0.514922 16 0.794922V6.08492C16 6.53492 15.46 6.75492 15.15 6.43492L13.18 4.46492C11.84 6.11492 11 8.17492 11 10.2949C11 13.4249 12.86 16.3049 15.51 17.8449C15.81 18.0249 16 18.3549 16 18.7049Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiConditionIcon);
export default __webpack_public_path__ + "static/media/ai_condition_icon.cab5ff08.svg";
export { ForwardRef as ReactComponent };